/**
 * @architecture-header 1
 * @layer module-ui
 * @domain settings-sso
 * @responsibility Compose independently tuned desktop and mobile SET-F07 SSO & Security pane
 *   surfaces: a read-only current-login-method display and a static enterprise-SSO explainer.
 * @state-owner none -- fully derived from props, no local state
 * @allowed-imports React; shared translator; app-level auth-provider type
 * @forbidden direct API client; any button, toggle, form, or dialog; sign-out-all-devices UI
 * @public-api SsoSettingsSurface
 * @side-effects none
 * @tests SsoSettingsSurface.test.tsx
 */

import type { WorkspaceAuthProvider } from '../../../app/config/environment';
import { useTranslator } from '../../../shared/model/use-workspace';
import './settings-sso.css';

const PROVIDER_LABEL: Record<WorkspaceAuthProvider, string> = {
  email: 'Email 驗證碼',
  google: 'Google',
};

export interface SsoSettingsSurfaceProps {
  linkedProviders: readonly WorkspaceAuthProvider[];
  mobile: boolean;
}

export function SsoSettingsSurface(props: SsoSettingsSurfaceProps) {
  const t = useTranslator();
  return (
    <section
      aria-label={t('SSO & Security')}
      className={`sso-settings-pane${props.mobile ? ' sso-settings-pane--mobile' : ' sso-settings-pane--desktop'}`}
    >
      <div className="sso-settings-pane__section">
        <span className="sso-settings-pane__label">{t('已連結的登入方式')}</span>
        <ul className="sso-settings-pane__providers">
          {props.linkedProviders.map((provider) => (
            <li key={provider}>{t(PROVIDER_LABEL[provider])}</li>
          ))}
        </ul>
      </div>

      <div className="sso-settings-pane__section">
        <span className="sso-settings-pane__label">{t('企業 SSO 即將推出')}</span>
        <p>{t('如需企業 SSO，請與我們聯絡。')}</p>
        <a href="mailto:support@vispo.app">{t('聯絡我們')}</a>
      </div>
    </section>
  );
}
